import CacheUtil from "../../../../../shared/lib/html5-software-library/src/ranj/util/CacheUtil";
import AbstractView from "../../../../../shared/src/ranj/equalture/view/AbstractView";

export default class FeedbackPanelView extends AbstractView {

    constructor(target) {
        super(target);
        this._origY = this._target.y;

        this._bgLeft = this._target.bg.bgLeft;
        this._bgLeft.xOrig = this._bgLeft.x;
        this._bgMid = this._target.bg.bgMid;
        this._bgMid.widthOrig = this._bgMid.getBounds().width;
        this._bgRight = this._target.bg.bgRight;
        this._bgRight.xOrig = this._bgRight.x;
        this._tf = this._target.bodyTextfield;
        this._tf.lineWidth = null;//dont wrap
        this._margin = this._bgMid.widthOrig - this._tf.getMeasuredWidth();
        this.show(false);
    }

    show(bool) {
        this._target.visible = bool;
    }

    setText(text, disappear = false) {
        CacheUtil.uncache(this._target);
        createjs.Tween.removeTweens(this._target);
        this.show(true);
        this._target.alpha = 1;
        this._target.y = this._origY;
        this._tf.text = text;
        this._fitBG();
        if (disappear) {
            createjs.Tween.get(this._target)
                .to({ y: this._origY + OFFSET, alpha: 0 }, 2000, createjs.Ease.quadIn)
                .call(() => { this.show(false); });
        }
    }

    _fitBG() {
        const tw = this._tf.getMeasuredWidth();
        const scale = (tw + this._margin) / this._bgMid.widthOrig;
        this._bgMid.scaleX = scale;
        const delta = (tw + this._margin - this._bgMid.widthOrig) / 2;
        this._bgLeft.x = this._bgLeft.xOrig - delta;
        this._bgRight.x = this._bgRight.xOrig + delta;
        CacheUtil.cache(this._target);
    }
};


const OFFSET = -100;